module.exports = __webpack_public_path__ + "img/div4.20d56051.jpg";